import axios from "axios";
import React from "react";
import styled from "styled-components";
import { Dynamic } from "../Context/ContextDynamic";
import BtnLoader from "../Utils/BtnLoader";
type TypeProps = {
  id: string;
  urlImgCarre: string;
  linkRedirectionCarre: string;
  urlImgRectangle?: string | undefined;
  linkRedirectionRectangle?: string | undefined;
};
const OneBusiness = ({
  id,
  urlImgCarre,
  linkRedirectionCarre,
  urlImgRectangle,
  linkRedirectionRectangle,
}: TypeProps) => {
  const { setLinkBusinessImgPro, setLinkBusinessPro, setIdBusinessPro } =
    Dynamic();
  const sendInfoToDisplayImage = (
    urlImg: string,
    redirection: string,
    id: string
  ) => {
    setLinkBusinessImgPro(urlImg);
    setLinkBusinessPro(redirection);
    setIdBusinessPro(id);
  };

  return (
    <StyledOneBusiness className="animate__animated animate__bounceIn">
      <div className="img-carre">
        {!urlImgCarre && <BtnLoader />}
        <img
          src={urlImgCarre}
          alt="image-pub"
          // onClick={() => goredirection(linkRedirectionCarre)}
          onClick={() =>
            sendInfoToDisplayImage(urlImgCarre, linkRedirectionCarre, id)
          }
        />
        {/* {urlImgRectangle && (
          <img className="img-recta" src={urlImgRectangle} alt="image-pub" />
        )} */}
      </div>
      {/* {urlImgRectangle && (
        <div className="img-rect">
          <img src={urlImgRectangle} alt="image-pub" />
        </div>
      )} */}
    </StyledOneBusiness>
  );
};

export default OneBusiness;
const StyledOneBusiness = styled.div`
  margin: 10px;
  max-width: 30%;
  display: flex;
  align-items: center;
  .img-carre {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    img {
      display: block;
      width: 100%;
      margin: 5px;
      cursor: pointer;
    }
    .img-recta {
    }
  }
  .img-rect {
    width: 100%;
    img {
      display: block;
      width: 100%;
    }
  }
  @media screen and (max-width: 445px) {
    min-width: 30%;
    margin: 2px;
    .img-carre {
      img {
        margin: 0px;
      }
    }
  }
`;
